import { buildUrl } from "../../../helpers/apiHelper";
import axios from "../../../lib/axios"

const getBrokerTransactionStatuses = async (
    config,
    options = {
        with: [],
        where: {}
    }
) => {
    const baseUrl = '/api/broker-transaction-statuses';

    return await axios
        .get(buildUrl(baseUrl, options), config)
        .then(({ data }) => data)
        .catch(({ response }) => {
            console.error(response)
            return []
        })
}

const brokerTransactionStatusAPI = {
    getBrokerTransactionStatuses
}

export default brokerTransactionStatusAPI
